import API from './api';

// TODO: Fix characterCase, characterCase naming inconsistencies between the FE and BE
export function checkAccessToResource({ characterType, characterCase, character }) {
  const resource = {
    character,
    characterType,
    characterCase
  };

  const payload = {
    app: 'dtt',
    resource
  };

  return new Promise((resolve, reject) => {
    API.post('/users/me/authorized', payload)
      .then(({ status }) => {
        resolve(status);
      })
      .catch(({ response: { status } }) => {
        reject(status);
      });
  });
}